/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CreateUpdateKeyValueDto } from './CreateUpdateKeyValueDto';
import {
    CreateUpdateKeyValueDtoFromJSON,
    CreateUpdateKeyValueDtoFromJSONTyped,
    CreateUpdateKeyValueDtoToJSON,
} from './CreateUpdateKeyValueDto';

/**
 * 
 * @export
 * @interface CreateUpdateKeyTestWithKeysDto
 */
export interface CreateUpdateKeyTestWithKeysDto {
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateKeyTestWithKeysDto
     */
    testIdentifier?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateKeyTestWithKeysDto
     */
    name?: string | null;
    /**
     * 
     * @type {Array<CreateUpdateKeyValueDto>}
     * @memberof CreateUpdateKeyTestWithKeysDto
     */
    keyValues?: Array<CreateUpdateKeyValueDto>;
}

/**
 * Check if a given object implements the CreateUpdateKeyTestWithKeysDto interface.
 */
export function instanceOfCreateUpdateKeyTestWithKeysDto(value: object): value is CreateUpdateKeyTestWithKeysDto {
    return true;
}

export function CreateUpdateKeyTestWithKeysDtoFromJSON(json: any): CreateUpdateKeyTestWithKeysDto {
    return CreateUpdateKeyTestWithKeysDtoFromJSONTyped(json, false);
}

export function CreateUpdateKeyTestWithKeysDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdateKeyTestWithKeysDto {
    if (json == null) {
        return json;
    }
    return {
        
        'testIdentifier': json['testIdentifier'] == null ? undefined : json['testIdentifier'],
        'name': json['name'] == null ? undefined : json['name'],
        'keyValues': json['keyValues'] == null ? undefined : ((json['keyValues'] as Array<any>).map(CreateUpdateKeyValueDtoFromJSON)),
    };
}

export function CreateUpdateKeyTestWithKeysDtoToJSON(value?: CreateUpdateKeyTestWithKeysDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'testIdentifier': value['testIdentifier'],
        'name': value['name'],
        'keyValues': value['keyValues'] == null ? undefined : ((value['keyValues'] as Array<any>).map(CreateUpdateKeyValueDtoToJSON)),
    };
}

